import React from 'react';
import { BRAND } from './brand';

/** Oar with a hatchet blade — reads at 20px and up. */
export function OarMark({ className = 'w-6 h-6' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M3.6 20.4 L12 12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      <path
        d="M11 11 L16.5 3.5 L20.5 7.5 L13 13 Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Logo({ size = 'md', tone = 'dark' }) {
  const box =
    size === 'sm' ? 'w-8 h-8 rounded-lg' : 'w-9 h-9 rounded-xl sm:w-10 sm:h-10';
  const mark = size === 'sm' ? 'w-[18px] h-[18px]' : 'w-5 h-5 sm:w-[22px] sm:h-[22px]';
  const text = size === 'sm' ? 'text-lg' : 'text-lg sm:text-xl';

  return (
    <div className="flex items-center gap-2.5">
      <div
        className={`${box} flex items-center justify-center bg-gradient-to-br from-sky-400 to-blue-700 text-white shadow-lg shadow-blue-900/30`}
      >
        <OarMark className={mark} />
      </div>
      <span
        className={`${text} font-bold tracking-tight ${
          tone === 'dark' ? 'text-white' : 'text-gray-900'
        }`}
      >
        {BRAND}
      </span>
    </div>
  );
}
